import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AnnouncementBanner = () => {
  const [announcement, setAnnouncement] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/announcement`)
      .then(res => res.json())
      .then(data => {
        if (data && data.active) {
          // Check if within date range
          const now = new Date();
          const startDate = data.startDate ? new Date(data.startDate) : null;
          const endDate = data.endDate ? new Date(data.endDate) : null;
          
          const isWithinDateRange = 
            (!startDate || now >= startDate) && 
            (!endDate || now <= endDate);
          
          if (isWithinDateRange) {
            setAnnouncement(data);
          }
        }
      })
      .catch(err => console.error('Error fetching announcement:', err));
  }, []);

  const handleButtonClick = () => {
    if (announcement.buttonLink) {
      if (announcement.buttonLink.startsWith('http')) {
        window.open(announcement.buttonLink, '_blank');
      } else {
        window.location.href = announcement.buttonLink;
      }
    }
  };

  if (!announcement) return null;

  return (
    <div 
      className="announcement-banner"
      style={{
        backgroundColor: announcement.backgroundColor,
        color: announcement.textColor
      }}
    >
      <div className="announcement-content">
        <div className="announcement-text">
          <h3 className="announcement-title">{announcement.title}</h3>
          <p className="announcement-description">{announcement.description}</p>
        </div>
        
        {announcement.buttonText && (
          <button 
            className="announcement-button"
            onClick={handleButtonClick}
            style={{
              borderColor: announcement.textColor,
              color: announcement.textColor
            }}
          >
            {announcement.buttonText}
          </button>
        )}
      </div>
    </div>
  );
};

export default AnnouncementBanner;
